import React from 'react';
import { ExperimentContext } from './context';

export const createExperimentHook = <A>(
  id: string,
  baseline: A,
  variants: { [key: string]: A }
) => {
  if (
    typeof id === 'undefined' ||
    typeof baseline === 'undefined' ||
    typeof variants === 'undefined'
  ) {
    throw new Error(
      'createExperimentHook expects 3 arguments: id, baseline, variants'
    );
  }
  return () => {
    const { selectedVariants, registerExperiment, setViewedExperiment } =
      React.useContext(ExperimentContext);

    const variantName =
      selectedVariants &&
      selectedVariants[id] &&
      selectedVariants[id].selectedVariant;

    React.useEffect(() => {
      if (registerExperiment) {
        registerExperiment({
          id,
          baseline,
          variants,
        });
      }
    }, [registerExperiment]);

    React.useEffect(() => {
      if (setViewedExperiment) {
        setViewedExperiment(
          id,
          variantName && variantName in variants ? variantName : 'baseline'
        );
      }
    }, [setViewedExperiment, variantName]);

    return variantName && variantName in variants
      ? variants[variantName]
      : baseline;
  };
};
